var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.352,
    height: 19,
    viewBox: "0 0 20.352 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1401 -193)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#768092",
    width: 5,
    height: 5,
    rx: 0.3,
    transform: "translate(1401 193)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#768092",
    width: 5,
    height: 5,
    rx: 0.3,
    transform: "translate(1401 200)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#768092",
    width: 5,
    height: 5,
    rx: 0.3,
    transform: "translate(1401 207)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#768092",
    strokeWidth: "3px",
    x2: 13.781,
    transform: "translate(1407.57 195.5)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#768092",
    strokeWidth: "3px",
    x2: 13.781,
    transform: "translate(1407.57 202.5)"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#768092",
    strokeWidth: "3px",
    x2: 13.781,
    transform: "translate(1407.57 209.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.93,0",
    transform: "translate(1397.57 202.965)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.c49c90678b9d0e976df92883c760998e.svg";
export { ForwardRef as ReactComponent };